import index from '../../../pages/i5gam/components/index'
import join from '../../../pages/i5gam/components/member/join'
import myPage from '../../../pages/i5gam/components/member/myPage'
import cs from '../../../pages/i5gam/components/cs/cs'
import cloud from '../../../pages/i5gam/components/cs/cloud'
import company from '../../../pages/i5gam/components/explan/company'
import goodsAdvntg from '../../../pages/i5gam/components/explan/goodsAdvntg'
import reqInstall from '../../../pages/i5gam/components/explan/reqInstall'
import findIdPw from '../../../pages/i5gam/components/member/findIdPw'

export default {
    I5GAM_ROUTERS:[
        {
            path:'/views/i5gam/index',
            name:'views.i5gam.index',
            component:index,
            props: true,
            meta: {
                authRequired:false,
                viewType:'index'
            }
        },
        {
            path:'/views/i5gam/member/join',
            name:'views.i5gam.member.join',
            component:join,
            props: true,
            meta: {
                authRequired:false,
                viewType:'etc'
            }
        },
        {
            path:'/views/i5gam/member/myPage',
            name:'views.i5gam.member.myPage',
            component:myPage,
            props: true,
            meta: {
                authRequired:false,
                viewType:'sub',
            }
        },
        {
            path:'/views/i5gam/explan/company',
            name:'views.i5gam.explan.company',
            component:company,
            props: true,
            meta: {
                authRequired:false,
                viewType:'sub'
            }
        },
        {
            path:'/views/i5gam/explan/goodsAdvntg',
            name:'views.i5gam.explan.goodsAdvntg',
            component:goodsAdvntg,
            props: true,
            meta: {
                authRequired:false,
                viewType:'sub'
            }
        },
        {
            path:'/views/i5gam/explan/reqInstall',
            name:'views.i5gam.explan.reqInstall',
            component:reqInstall,
            props: true,
            meta: {
                authRequired:false,
                viewType:'sub'
            }
        },
        {
            path:'/views/i5gam/cs/cloud',
            name:'views.i5gam.cs.cloud',
            component:cloud,
            props: true,
            meta: {
                authRequired:false,
                viewType:'sub'
            }
        },
        {
            path:'/views/i5gam/cs/cs',
            name:'views.i5gam.cs.cs',
            component:cs,
            props: true,
            meta: {
                authRequired:false,
                viewType:'sub'
            }
        },
        {
            path:'/views/i5gam/member/findIdPw',
            name:'views.i5gam.member.findIdPw',
            component:findIdPw,
            props: true,
            meta: {
                authRequired:false,
                viewType:'etc'
            }
        },
    ],
}